// extracted by mini-css-extract-plugin
var _1 = "tjs-story-editor__body";
var _2 = "tjs-story-editor__cancelBtn tjs-_buttons__btn tjs-_buttons__btn-transparent";
var _3 = "tjs-story-editor__field tjs-_form__field tjs-_form__input";
var _4 = "tjs-story-editor__header";
var _5 = "tjs-story-editor__inner";
var _6 = "tjs-story-editor__is-mounted";
var _7 = "tjs-story-editor__is-mounted";
var _8 = "tjs-story-editor__popupEditor";
var _9 = "tjs-story-editor__saveBtn tjs-_buttons__btn tjs-_buttons__btn-primary";
export { _1 as "body", _2 as "cancelBtn", _3 as "field", _4 as "header", _5 as "inner", _6 as "is-mounted", _7 as "isMounted", _8 as "popupEditor", _9 as "saveBtn" }
export default { "body": _1, "cancelBtn": _2, "field": _3, "header": _4, "inner": _5, "is-mounted": _6, "isMounted": _7, "popupEditor": _8, "saveBtn": _9 }
